/* ==========================================================================
   Solid Viibe — scroll-snap carousel arrows
   Ported from the approved prototype's sv-common.js.
   ========================================================================== */
(function () {
  'use strict';

  function init(scope) {
    scope.querySelectorAll('[data-carousel]').forEach(function (root) {
      if (root.dataset.carouselReady === 'true') return;
      root.dataset.carouselReady = 'true';

      var track = root.querySelector('[data-carousel-track]');
      if (!track) return;

      var buttons = root.querySelectorAll('[data-carousel-prev], [data-carousel-next]');

      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }

      function sync() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        buttons.forEach(function (btn) {
          var next = btn.hasAttribute('data-carousel-next');
          btn.disabled = maxScroll <= 1
            ? true
            : next ? track.scrollLeft >= maxScroll - 2 : track.scrollLeft <= 2;
        });
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
          track.scrollBy({ left: dir * step(), behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
